import { motion, useInView } from "framer-motion";
import aboutImg from "../assets/about-img.jpg";
import { useRef } from "react";
import WhyChooseUs from "./subComponents/WhyChooseUs";
import OurCourse from "./subComponents/OusCourse";
import Testimonials from "./subComponents/Testimonials";
import Advantages from "./subComponents/Advantages";
import OurTech from "./subComponents/OurTech";
const About = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  // ANIMATION
  const leftVariants = {
    hidden: { x: -200, opacity: 0 }, // Start from the left
    visible: {
      x: 0,
      opacity: 1,
      transition: { duration: 1.5, ease: "easeInOut" }, // 1 second duration
    },
  };

  const rightVariants = {
    hidden: { y: 200, opacity: 0 }, // Start from the right
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 1.5, ease: "easeInOut" }, // 1 second duration
    },
  };

  return (
    <div className="" id="about">
      {/* About Us Section */}
      <section className="padding bg-white w-full py-12 animate-fadeIn">
        <div
          className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center"
          ref={ref}
        >
          <motion.div
            className="max-sm:text-center"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={leftVariants}
          >
            <h2 className="text-5xl font-extrabold text-blue-700 mb-6 uppercase tracking-wide">
              About Us
            </h2>
            <p className="text-lg leading-relaxed text-gray-800 mb-8">
              Our academy, situated in the heart of Calicut city, was
              established in 2019 with the goal of excelling in various
              competitive entrance exams such as NEET, JEE, CUET, and
              CA/CMA/ACCA foundations. We provide high-quality materials,
              experienced faculty, doubt-clearing sessions, continuous
              evaluation, practical classes, and personalized attention.
            </p>
            <h3 className="text-4xl font-semibold text-blue-600 mb-4">
              Mission
            </h3>
            <p className="text-md leading-relaxed text-gray-700 mb-6">
              To develop a single, reliable platform for all competitive
              entrance examinations.
            </p>
            <h3 className="text-4xl font-semibold text-blue-600 mb-4">
              Vision
            </h3>
            <p className="text-md leading-relaxed text-gray-700">
              To become the most trusted coaching institute for competitive
              exams, promoting practical, high-quality education to support
              student growth and success.
            </p>
          </motion.div>
          <motion.div
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={rightVariants}
          >
            <img
              src={aboutImg}
              alt="Academy Image"
              className="rounded-lg shadow-lg w-full "
            />
          </motion.div>
        </div>
      </section>
      {/* Why Choose Us Section */}
      <WhyChooseUs />
      {/* Our Courses Section */}
      <OurCourse />
      {/* Testimonials Section */}
      <Testimonials />
      {/* Advantage Section */}
      <Advantages />
      {/* Our Tech */}
      <OurTech />
    </div>
  );
};

export default About;
